/**
 * RubticResults component displays the rubric criteria and ratings along with the grading history.
 */

import { base_url } from "Constants";
import React,{useEffect} from "react";
import { useParams, Link } from "react-router-dom";
import httpService from "services/httpService";

const RubricResults = ({
  submission,
  programId,
  rubricData,
  gradingHistory,
  totalScore,
})=> {

  const { courseId, labId } = useParams();
  const [submissionDetail,SetSubmissionDetail] = React.useState(null);
  // Function to calculate the maximum marks for a given row
  function maxOfMarks(ratings, row_index) {
    // Initialize max to 0
    let max = 0;

    // Iterate over the ratings
    for (let i = 0; i < ratings.length; i++) {
      // If the current rating's mark is greater than max, update max
      if (max < parseFloat(ratings[i].mark)) max = parseFloat(ratings[i].mark);
    }

    // Initialize score to 0
    let score = 0;

    // If the grading history has a mark for the current criteria, update score
    if (gradingHistory.hasOwnProperty(rubricData[row_index].criteria_id))
      score = parseFloat(
        gradingHistory[rubricData[row_index].criteria_id].mark
      );

    // Return the score and max as a JSX element
    return (
      <span>
        <b>{score}</b>/<b>{max}</b>
      </span>
    );
  }
  useEffect(() => {
    const fetchSubmissionDetails = async () => {
      try{
        const studentId = submission?.student;
        const url = base_url + '/evalpro/get_submission_details/' + programId;
        const response = await httpService.get(url);
        if (response.status === 200) {
          SetSubmissionDetail(response.data.submission);
        } else {
          displayGlobalMessage(error.response.data.detail || "Undefined error", "error");
        }
      }
      catch (error) {
        console.log("Error in fetchig Submission Detail.");
      }
    }
    fetchSubmissionDetails();
  }, []);
  // Function to calculate the total marks given
  function calcMarksGiven() {
    // Map the grading history object to an array of given scores
    let givenScores = Object.keys(gradingHistory).map(
      (key, index) => gradingHistory[key].mark
    );

    // Reduce the array of given scores to a sum
    let sum = givenScores.reduce((a, b) => a + parseFloat(b), 0);

    // Return the sum and total score as a JSX element
    return (
      <div>
        Rubrics Marks awarded: <b>{sum}</b> out of <b>{totalScore}</b>
      </div>
    );
  }

  return (
    <div>
      <div className="cont">
        <div className="pl-5 pr-5">
          <div>{calcMarksGiven()}</div>

          
            {
              submission?

              <div>For More Detail: 
              <Link 
                to={`/courseware/course/${courseId}/content/labs/${labId}/programming/${programId}/SubjectiveGrading/${submission.student}`}
                state={{submission: submissionDetail}}
                className="pl-2"
              >
                Click Here
              </Link>
              </div>
              :
              <div>
                You have not submitted the code yet.
              </div>
            }

          <br />
        </div>
      </div>
    </div>
  );
}
export default RubricResults;
